/*eslint-disable*/
import { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import TextInputField from '../../components/textInputField'
import {
  Box,
  Button,
  Typography,
} from '@mui/material'

// components
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import styles from './editName.module.scss'
import LoadingSpinner from '../../components/loadingSpinner'
import Breadcrumbs from '../../components/Breadcrumbs'

// hooks
import useUser from '../../hooks/useUser'
import ButtonWithLoader from '../../components/buttonWithLoader'
import { useTranslation } from 'react-i18next'

// helpers
import {
  getInitialUser,
  makeEditUserDTO,
  areFormValuesChanged,
} from './editName.helpers'
import { getUserId } from '../../helpers/user'

//services
import { updateUser } from '../../services/user'

const cancelStyle = {
  backgroundColor: 'rgba(98, 81, 55, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(102,90,71, 0.20)',
  },
  '&:disabled': {
    backgroundColor: 'rgba(138, 115, 92, 0.05)',
  },
  '&:focus': {
    backgroundColor: 'rgba(112, 99, 79, 0.1)',
  },
}

const submitStyle = {
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#665A47',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}
const EditName = () => {
  const navigate = useNavigate()
  const ID = getUserId()
  const { user: userObj, isUserLoading } = useUser(ID)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [inputUser, setInputUser] = useState({})
  const { t } = useTranslation()

  const breadcrumbPath = [
    {label: 'my-profile-tab', path: '/user-profile'},
    {label: 'edit-profile-name-title'},
  ]

  useEffect(() => {
       if (userObj && !inputUser.firstName) {
        const initialUser = getInitialUser(userObj)
        setInputUser(initialUser)
    }
  }, [userObj])

  const handleUpdateUserSuccess = () => {
    setErrors({})
    navigate(`/user-profile`)
    navigate(0)
  }

  const handleUpdateUserFailure = (error) => {
    toast.error(error?.message)
  }

  const setAsSubmitted = () => setIsSubmitting(false)

  const onSubmit = () => {
    setIsSubmitting(true)
    const userDTO = makeEditUserDTO(userObj, inputUser)
    updateUser(userDTO, userObj?.id)
      .then(handleUpdateUserSuccess)
      .catch(handleUpdateUserFailure)
      .finally(setAsSubmitted)
  }

  if (isUserLoading) {
    return <LoadingSpinner />
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedUser = { ...inputUser, [name]: value };
    setInputUser(updatedUser)

    if(name == 'firstName'){
      setErrors(prev => {
        if (value.trim() === "") {
          return {...prev, firstName: t('label-mandatory-first-name-field') }
        }
        const {firstName, ...rest} = prev
        return rest
      })
    }

  };

 const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  const handleCancel = (e) => {
    e.preventDefault()
    navigate('/user-profile')
  }
 
  return (
    <Box sx={{ width: '100vw' }}>
      <div
        style={{ backgroundColor: '#F5F5F5', width: '100vw', padding: '20px' }}
      >
        <Breadcrumbs crumbs={breadcrumbPath} />
      </div>
      <div
        className={styles.editName}
      >
      <Link
              to="/user-profile"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIcon
                sx={{
                  marginRight: '2px',
                  padding: '5px 0 0 0',
                  color: 'black',
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontFamily: 'JohnsonText,Arial,sans-serif',
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '23.2px',
                  padding: '5px 0 0 0',
                  color: 'black',
                }}
              >
                {t('user-profile-back')}
              </Typography>
            </Link>
      <h1>{t('edit-profile-name-title')}</h1>
      <p>{t('edit-profile-name-notification')}</p>
       <TextInputField
          className={styles.userInput}
          label={t('first-name')}
          id={'firstName'}
          required={true}
          value={inputUser.firstName}
          error={errors.firstName}
          onChange={handleChange}
        />
        <TextInputField
          className={styles.userInput}
          label={t('last-name')}
          id={'lastName'}
          required={false}
          value={inputUser.lastName}
          error={errors.lastName}
          onChange={handleChange}
        />
            </div>
      <div className={styles.buttoncontainer}>

         <ButtonWithLoader
            onClick={handleSubmit}
            loading={isSubmitting}
            disabled={inputUser.firstName === '' || inputUser.firstName === undefined || !inputUser?.firstName?.trim()}
            label={t('edit-profile-name-save-button')}
            className="primary-btn"
            sx={{
            ...submitStyle,
            marginTop: '20px',
            width: { xs: '80%', sm: '140px'  },
            marginRight: '15px',
            height: '40px',
            }}
        />
        <Button
          onClick={handleCancel}
          type="submit"
          className="secondary-btn"
          variant="contained"
          disabled={isSubmitting || !areFormValuesChanged}
          disableElevation={true}
          sx={{
            ...cancelStyle,
            marginTop: '20px',
            marginLeft: '0px',
            paddingLeft: '0px',
            left: -15,
            height: '40px',
            color: '#000000',
            width: { xs: '80%', sm: '120px'  }
          }}
        >
          {t('group-modal-cancel-cta')}
        </Button>
      </div>
    </Box>
  )
}

export default EditName;
